export default "__VITE_ASSET__DlTOGkaR__"